export const getWindowOrientation = (
  width: number = window.innerWidth,
  height: number = window.innerHeight,
) => (width > height ? 'landscape' : 'portrait')
